<template>
    <div class="footer wow fadeInUp">
        <div class="rowFluid">
            <div class="span12">
            <div class="container">
                <div class="footer_content">
                <div class="span4 col-xm-12">
                    <div class="footer_list">
                    <div class="span6">
                        <div class="bottom_logo"> <img :src="picData[0]" alt="微信服务号二维码" /></div>
                    </div>
                    <div class="span6 col-xm-12">
                        <div class="quick_navigation">
                        <div class="quick_navigation_title">快速导航</div>
                        <ul>
                            <li> <a href="/" title="首页">首页</a> </li>
                            <li> <a href="/soultion" title="解决方案">解决方案</a> </li>
                            <li> <a href="/aboutus" title="关于我们">关于我们</a> </li>
                            <!--
                            <li> <a href="/buildPlan" title="客户案例">客户案例</a> </li>
                            <li> <a href="/a/jianzhanfangan/" title="建站方案">建站方案</a> </li>
                            <li> <a href="/a/xinwenzixun/" title="新闻资讯">新闻资讯</a> </li>
                            <li> <a href="/a/jishuzhichi/" title="技术支持">技术支持</a> </li>
                            -->
                            <li> <a href="/a/lianxiwomen/" title="联系我们">联系我们</a> </li>
                        </ul>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="span4 col-xm-6 col-xs-12">
                    <div class="footer_list">
                    <div class="footer_link">
                        <div class="footer_link_title">友情链接</div>
                        <ul id="frientLinks">
                            <!--
                            <li><a href='https://crm.gdhp.cn' target='_blank'>华浦汽修</a> </li>
                            -->
                            <li><a href='http://www.gdhp.cn/pcdownload/' target='_blank'>华浦汽修管家</a> </li>
                        </ul>
                    </div>
                    </div>
                </div>
                <div class="span4 col-xm-6 col-xs-12">
                    <div class="footer_list">
                    <div class="footer_cotact">
                        <div class="footer_cotact_title">联系方式</div>
                        <ul>
                        <li><span class="footer_cotact_type">地址：</span><span class="footer_cotact_content">佛山市禅城区石湾镇街道港口路11号二座五层B-508号</span></li>
                        <li><span class="footer_cotact_type">电话：</span><span class="footer_cotact_content"><a href="tel:191-1486-0806" class="call">191-1486-0806</a></span></li>
                        <li><span class="footer_cotact_type">网址：</span><span class="footer_cotact_content"><a href="www.gdhp.cn" title="官网">www.gdhp.cn</a></span></li>
                        <li><span class="footer_cotact_type">邮箱：</span><span class="footer_cotact_content">service@gdhp.cn</span></li>
                        </ul>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div class="copyright">Copyright &copy; 2022-2032  版权所有 <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022026079号</a> </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  data () {
    return {
      picData: [
        require('../../assets/images/weixin.png')
      ]
    }
  }
}
</script>
<style lang="less" rel="stylesheet/less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/footerBar/footerBar.vue